export default {
  requestReceived:            'Recebemos o seu pedido',
  remindSendDocuments:        'Não esqueça de enviar uma cópia do seu Documento de Identidade, Procuração Autenticada - Documento de Identidade da pessoa que você está representando.para o email <a href="mailto:meusdados@simplic.com.br">meusdados@simplic.com.br</a>',
  remindContactCallCenter:    'Caso tenha solicitado a atualização ou correção de algum dado, por favor entre em contato com a nossa central de atendimento.',
  informContactAccountHolder: 'Após a validação dos documentos, enviaremos a resposta do seu pedido para o email do titular da conta',
};
